/* eslint-disable camelcase */
import React from 'react';
import { useSelector } from 'react-redux';

import { ErrorContainer, ErrorMessageWrapper, ErrorHeader, ErrorText } from './response-error.styled';
import ErrorImage from './error-image';

const EditExpiredError = () => {
  const { oldForm, userCustomTexts } = useSelector((state) => state.form);
  
  return (
    <ErrorMessageWrapper>
      <ErrorContainer>
        <ErrorImage />
        <ErrorHeader>Edit link expired</ErrorHeader>
        <ErrorText>{!oldForm && <p>{userCustomTexts.edit_link_expired}</p>}</ErrorText>
      </ErrorContainer>
    </ErrorMessageWrapper>
  );
};

export default EditExpiredError;
